import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { Button, Icon, AppBar, Tabs, Tab } from '@material-ui/core';
import { childrenRef, paymentsRef } from '../../firebase';
import { AvatarIconComponent } from "../../components/icon_components";
import Paper from "@material-ui/core/Paper";
import moment from 'moment';

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#3197e7"
  },
    title: {
        paddingLeft: '80px',
        paddingRight: '80px',
        paddingTop: '35px',
  },

  bigIndicator: {
    backgroundColor: "#3197e7",
    color: "#3197e7"
  },
  textcolor: {
    color: "#3197e7"
    },
    card: {
        marginTop: "10px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#fff"
    },
    cardHover: {
        marginTop: "30px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#AAA"
    },
    cardAvatar: {
        maxWidth: "130px",
        maxHeight: "130px",
        borderRadius: "50%",
        overflow: "hidden",
        boxShadow:
            "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    },

    textAlign: {
        textAlign: "center"
    },
    cardSubtitle: {
        color: "#999",
        fontSize: "1em",
        textTransform: "uppercase",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardTitle: {
        fontSize: "1.3em",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardDescription: {
        padding: "5px 10px",
    },
    cardActions: {
        height: "auto",
        display: "inline"
  },
  button: {
    width: "150px",
    float: "right"
  },
  bigAvatar: {
    width: 80,
    height: 80
    }
});

class KidDetails extends Component {
    constructor(props) {
        super(props);
        const { id } = props.match.params;
        this.state = {
            loading: true,
            open: false,
            deleteStatus: false,
            deleteError: false,
            redirect: false,
            updateRequest: false,
            bgColor: '#FFF',
            id,
            firstName: '',
            lastName: '',
            accountId: '',
            deposit: '',
            saveDate: '',
            value: 0,
            eventRedirect: false,
            location: '',
            payments: [],
            sponsors: [],
        };
    }

    componentDidMount() {
        childrenRef.doc(this.state.id).get()
        .then((snapshot) => {
            const {
                firstName, 
                lastName, 
                accountId, 
                deposit, 
                saveDate, 
                dob, 
                location,
                state,
                city, 
                street,
                zipCode
            } = snapshot.data();
            childrenRef.doc(this.state.id).collection('events').get()
            .then((querSnapshot) => {
                var events = [];
                querSnapshot.forEach(snapshot => {
                    events.push({ id: snapshot.id, data: snapshot.data() });
                });

                paymentsRef.where('childId', '==', snapshot.id).orderBy('date', 'desc').get()
                .then((querSnapshot) => {
                    querSnapshot.forEach(snapshot => {
                        const { payments } = this.state;
                        payments.push(snapshot.data());
                        this.setState({payments});
                    });
                    const { payments } = this.state;
                    var arr = [];
                    var sponsors = [];
                    for (var i = 0; i < payments.length; i++) {
                        if (!arr.includes(payments[i].email)) {
                            arr.push(payments[i].email);
                            sponsors.push({ name: payments[i].name, email: payments[i].email, amount: parseInt(payments[i].amount, 10) / 100 })
                        } else {
                            sponsors[arr.indexOf(payments[i].email)].amount += parseInt(payments[i].amount, 10) / 100;
                        }
                    }

                   this.setState({ sponsors });
                });

                this.setState({ 
                    events,
                    firstName,
                    lastName,
                    accountId,
                    deposit,
                    saveDate,
                    dob,
                    location,
                    state,
                    city,
                    street,
                    zipCode,
                    loading: false,
                 });
            });
        });
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };


    eventDetail = id => {
        this.setState({
            eventUrl: '/events/update/' + id,
            eventRedirect: true
        });
    };

    render() {
        const { classes } = this.props;
        if (this.state.eventRedirect) {
            return(
                <Redirect to={this.state.eventUrl} />
            );
        }
        
        if (this.state.loading) {
            return (
                <h2>Loading...</h2>
            );
        }
        
        if (this.state.updateRequest) {
            var updateId = "/kids/update/" + this.state.id;
            return (
                <Redirect to={updateId} />
            );
        }

        var eventsSections = [];

        this.state.events.forEach((event, index) => {
            var bg = '#FFF';

            if(moment(event.data['date'], 'MM/DD/YYYY').isBefore()) {
                bg = '#AAA';
            }

            eventsSections[index] =
            <Card onClick={() => this.eventDetail(event.id)} style={{ background: bg, paddingBottom: '20px' }} onMouseOver={this.cardHovering} onMouseLeave={this.cardNormal} className={classes.card} >
                <CardContent>
                    <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid alignContent='center' item xs={12} sm={3} md={2} lg={2} xl={2}>
                            <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <img src="https://firebasestorage.googleapis.com/v0/b/fir-kbaaz.appspot.com/o/avatars%2Fuser.png?alt=media&token=692478e2-252e-4503-8b8b-5553f5b58556" alt="..." style={{ height: '80px' }} />
                            </div>
                        </Grid>
                        <Grid spacing={0} container item xs={12} sm={8} md={9} lg={9} xl={9} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <Typography variant='title' className={classes.cardDescription}>
                                    {event.data['name']}
                                </Typography>
                                <Typography component="p" className={classes.cardDescription}>
                                    {event.data['date']}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <Typography component="p" className={classes.cardDescription}>
                                    ${event.data['total']}
                                </Typography>

                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        });

        var paymentsSection = [];
        var total = 0;

        this.state.payments.forEach((payment, index) => {
            total = total + (parseInt(payment['amount'], 10) / 100);
            paymentsSection[index] =
                <Card style={{ paddingBottom: '20px' }} className={classes.card} >
                    <CardContent>
                        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <Typography variant='title' className={classes.cardDescription}>
                                    {payment['name']}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <Typography component="p" className={classes.cardDescription}>
                                    ${parseInt(payment['amount'], 10) / 100}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
        });

        var sponsorsSection = [];

        this.state.sponsors.forEach((sponsor, index) => {
            sponsorsSection[index] = (
                <Card style={{ paddingBottom: '20px' }} className={classes.card} >
                    <CardContent>
                        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <Typography variant='title' className={classes.cardDescription}>
                                    {sponsor['name']}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <Typography component="p" className={classes.cardDescription}>
                                    ${parseInt(sponsor['amount'], 10)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
);
        });
    let backgroundColor = "";
    if (sessionStorage.getItem("kidsAvatar")) {
      let colorObject = JSON.parse(sessionStorage.getItem("kidsAvatar"));

      let color = colorObject.find(o => o.kidid == this.state.id);
      if (color) backgroundColor = color.color;
    }

        return (
            <div style={{ padding:'40px' }}>
                <Card style={{ background: this.state.bgColor }} onMouseOver={this.cardHovering} onMouseLeave={this.cardNormal} onClick={() => this.setState({ updateRequest: true })} className={classes.card} >
                    <CardContent>
                        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid
                alignContent="center"
                item
                xs={12}
                sm={3}
                md={2}
                lg={2}
                xl={2}
              >
                <AvatarIconComponent
                  backgroundColor={backgroundColor}
                  colorSet={true}
                  className={classes.bigAvatar}
                >
                  <div style={{ textTransform: "uppercase" }}>
                    {this.state.firstName.substring(0, 1) +
                      this.state.lastName.substring(0, 1)}
                  </div>
                </AvatarIconComponent>
              </Grid>
              <Grid
                spacing={0}
                container
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Grid item xs={8} sm={5} md={5} lg={5} xl={5}>
                  <Typography
                    variant="title"
                    className={classes.cardDescription}
                  >
                    {this.state.firstName + " " + this.state.lastName}
                  </Typography>
                  <Typography component="p" className={classes.cardDescription}>
                    {this.state.dob}
                  </Typography>
                </Grid>
                <Grid item xs={8} sm={5} md={5} lg={5} xl={5}>
                  <Typography component="p" className={classes.cardDescription}>
                    {this.state.location}
                  </Typography>
                  <Typography component="p" className={classes.cardDescription}>
                    ${total}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                <Button
                  onClick={() => {
                    this.setState({ updateRequest: true });
                  }}
                  style={{
                    backgroundColor: "#9C27B0",
                    color: "#fff"
                  }}
                  className={classes.button}
                  variant="outlined"
                  color="primary"
                >
                  Edit Details
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Paper square>
          <Tabs
            classes={{
              indicator: classes.bigIndicator,
              color: classes.textcolor
            }}
            style={{ color: "#3197e7" }}
            centered
            value={this.state.value}
            onChange={this.handleChange}
          >
            <Tab label="Events" />
            <Tab label="Transactions" />
            <Tab label="Sponsors" />
          </Tabs>
        </Paper>
        {this.state.value === 0 && eventsSections}
        {this.state.value === 1 && paymentsSection}
        {this.state.value === 2 && sponsorsSection}
      </div>
    );
  }
}

KidDetails.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(KidDetails);




// WEBPACK FOOTER //
// ./src/components/Kids/KidDetails.js